export default __webpack_public_path__ + "static/media/org-mail.6e1a02d2.svg";